import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DSIcon } from '@spotahome/ui-library/base';

import { trans } from '@spotahome/soyuz/client';

import {
  getLocoKeys,
  PROPERTY_RULES_ICONS
} from '../utils/propertyRulesHelper';

import './PropertyRule.scss';

const PropertyRule = ({ ruleName, ruleValue, info = '' }) => {
  const ruleClassName = classNames('property-rule');
  return (
    <div className={ruleClassName}>
      <DSIcon
        name={
          PROPERTY_RULES_ICONS[ruleName][ruleValue] ||
          PROPERTY_RULES_ICONS[ruleName]
        }
      />
      <div className="property-rule__text">
        {trans(`property.rule.${getLocoKeys(ruleName, ruleValue)}`)}
        {info ? <p className="property-rule__subText">{trans(info)}</p> : null}
      </div>
    </div>
  );
};

PropertyRule.propTypes = {
  ruleName: PropTypes.string.isRequired,
  info: PropTypes.string,
  ruleValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

export default PropertyRule;
